// eslint-disable-next-line
export default {
  icons: {
    logo: require("@src/assets/darkLogo.svg").default,
    swap: require("@src/assets/icons/darkSwap.svg").default,
    arrowDown: require("@src/assets/icons/darkArrowDown.svg").default,
    group: require("@src/assets/icons/sortDownDark.svg").default,
    done: require("@src/assets/icons/darkDone.svg").default,
    autostaking: require("@src/assets/icons/autostaking.svg").default
  }
};
